import axios from 'axios'
import { PAYMENT_ENDPOINT } from '../../endpoints'

export async function getPayments(firstname, lastname, email) { 
    
    const url = `${PAYMENT_ENDPOINT}?firstname=${firstname}&lastname=${lastname}&email=${encodeURIComponent(email)}`

    const response = await axios.get(url)
    
    return response.data
}

export async function getPaymentsInitiatedByBudgetId(budget_id) {
  if (!budget_id) return []

  try {
    const response = await axios.get(`${PAYMENT_ENDPOINT}/getByBudgetId/${budget_id}/initiatedReceipt`)
    return response.data?.data || []
  } catch (error){
    console.log(error)
    return []
  }
}
